<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-75">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-icon">
              <md-icon>{{ statInspIcon }}</md-icon>
            </div>
            <h4 class="title">Filtered Statutory Inspection Items</h4>
          </md-card-header>
          <md-card-content
            ><div class="md-layout">
              <label class="md-layout-item md-form-label">Search:</label>
              <div class="md-layout-item md-size-50">
                <md-field>
                  <md-input
                    type="search"
                    clearable
                    placeholder="e.g. site name, building name/address or serial no"
                    v-model="searchCriteria.searchText"
                    @keydown.enter.native="searchStatItems()"
                  ></md-input>
                  <md-button
                    class="md-icon-button md-primary"
                    @click="searchStatItems()"
                  >
                    <md-icon>search</md-icon>
                  </md-button>
                </md-field>
              </div>
            </div>
            <md-table
              v-model="statPagedInspItemsResult.items"
              class="table-hover"
              table-header-color="primary"
            >
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Serial Number">
                  {{ item.serialNo }}
                </md-table-cell>
                <md-table-cell md-label="Site Name">
                  {{ item.siteName }}
                </md-table-cell>
                <md-table-cell md-label="Building Name">
                  {{ item.buildingName }}
                </md-table-cell>
                <md-table-cell md-label="Report Date">{{
                  item.reportDate | moment("DD-MMM-YYYY")
                }}</md-table-cell>
                <md-table-cell md-label="Time">{{ item.time }}</md-table-cell>
                <md-table-cell md-label="Description">
                  {{ item.description }}
                </md-table-cell>
                <md-table-cell>
                  <md-button
                    class="md-just-icon md-primary"
                    @click="viewItem(item.id, item.statInspId)"
                  >
                    <md-tooltip>View Stat Insp Item</md-tooltip>
                    <md-icon>forward</md-icon>
                  </md-button>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
          <md-card-actions md-alignment="space-between">
            <div class>
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} outstanding
                items
              </p>
            </div>
            <pagination
              class="pagination-no-border pagination-default"
              v-model="searchCriteria.currentPage"
              :value="searchCriteria.currentPage"
              :per-page="searchCriteria.itemsPerPage"
              :total="total"
              @input="changePage"
            ></pagination>
          </md-card-actions>
        </md-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-25">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-icon">
              <md-icon>find_in_page</md-icon>
            </div>
            <h4 class="title">Additional Filters</h4>
          </md-card-header>
          <md-card-content>
            <md-field>
              <label for="contractorRegion">Contractor</label
              ><md-select
                v-model="filterCriteria.contractorRegionId"
                name="contractorRegion"
                id="contractorRegion"
                @md-selected="changeStatus()"
              >
                <md-option value="0">All</md-option>
                <md-option
                  v-for="contractorRegion in permittedContractorRegions"
                  :key="contractorRegion.id"
                  :value="contractorRegion.id"
                >
                  {{ contractorRegion.name }}
                </md-option>
              </md-select>
            </md-field>
            <md-field>
              <label for="type">Item Type</label>
              <md-select
                v-model="filterCriteria.statInspItemTypeId"
                name="type"
                id="type"
                @md-selected="changeStatus()"
              >
                <md-option value="0">All</md-option>
                <md-option
                  v-for="type in statInspItemTypeOptions"
                  :key="type.id"
                  :value="type.id"
                  >{{ type.name }}</md-option
                >
              </md-select>
            </md-field>
            <md-field>
              <label for="status">Item Status</label>
              <md-select
                v-model="filterCriteria.statInspItemStatusId"
                name="status"
                id="status"
                @md-selected="changeStatus()"
              >
                <md-option
                  v-for="status in statInspItemStatusOptions"
                  :key="status.id"
                  :value="status.id"
                  >{{ status.name }}</md-option
                >
              </md-select>
            </md-field>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Pagination } from "@/components";
export default {
  components: {
    Pagination
  },
  data() {
    return {
      firstLoad: true,
      filterCriteria: {
        statInspItemTypeId: 0,
        statInspItemStatusId: -1,
        contractorRegionId: "0"
      },
      searchCriteria: {
        searchText: undefined,
        currentPage: 1,
        itemsPerPage: 15
      }
    };
  },
  async created() {
    this.$route.query.typeId !== undefined
      ? (this.filterCriteria.statInspItemTypeId = this.$route.query.typeId)
      : 0;
    this.$route.query.statusId !== undefined
      ? (this.filterCriteria.statInspItemStatusId = this.$route.query.statusId)
      : 1;
    this.$route.query.contractorRegionId !== undefined
      ? (this.filterCriteria.contractorRegionId = this.$route.query.contractorRegionId)
      : "0";

    await this.getStatInspItems();
  },
  computed: {
    ...mapGetters({
      statInspIcon: "stat-insp/icon",
      statInspItemTypeOptions: "stat-insp/statInspItemTypes",
      statInspItemStatusOptions: "stat-insp/statInspItemStatuses",
      statPagedInspItemsResult: "stat-insp/statPagedInspItemsResult"
    }),
    to() {
      let highBound = this.from + this.searchCriteria.itemsPerPage;
      if (this.statPagedInspItemsResult.total < highBound) {
        highBound = this.statPagedInspItemsResult.total;
      }
      return highBound;
    },
    from() {
      return (
        this.searchCriteria.itemsPerPage * (this.searchCriteria.currentPage - 1)
      );
    },
    total() {
      return this.statPagedInspItemsResult.total;
    },
    permittedContractorRegions() {
      return this.$auth.profile.contractorRegions;
    }
  },
  methods: {
    async searchStatItems() {
      this.firstLoad = true;
      this.getStatInspItems();
    },
    async changeStatus() {
      this.firstLoad = true;
      this.getStatInspItems();
    },
    async changePage() {
      if (!this.firstLoad) this.getStatInspItems();
      this.firstLoad = false;
    },
    async getStatInspItems() {
      this.$store.dispatch("stat-insp/getPagedStatInspItems", {
        filterCriteria: this.filterCriteria,
        searchCriteria: this.searchCriteria
      });
    },
    viewItem(id, statInspId) {
      this.$router.push({
        query: {
          typeId: this.filterCriteria.statInspItemTypeId,
          statusId: this.filterCriteria.statInspItemStatusId
        }
      });
      this.$router.push({
        name: "Stat Insp Item View",
        params: { statInspId: statInspId, statInspItemId: id },
        query: { fromFilter: true }
      });
    }
  }
};
</script>

<style></style>
